import { Badge } from "@/components/ui/badge";

export const SponsoredBadge = () => {
  return (
    <Badge variant={"brandSoft"} className={"my-4 px-1.5"}>
      Treść sponsorowana
    </Badge>
  );
};
